import type { MediaTrack } from '$types';
import { normalizeTrackLanguage, resolveTrackLanguage, sameTrackLanguage } from '../track-language';
export { sameTrackLanguage } from '../track-language';

export function trackLanguage(t: Pick<MediaTrack, 'lang' | 'title'>): string {
  return resolveTrackLanguage({ language: t.lang, title: t.title });
}
const commentary = (t: MediaTrack): boolean => /\b(commentary|commentaire|audio description|descriptive|described)\b/i.test(t.title ?? '');
function orderedMatches(tracks: MediaTrack[], preferred: string): MediaTrack[] {
  const want=normalizeTrackLanguage(preferred);
  return tracks.filter(t=>sameTrackLanguage(trackLanguage(t),want)).sort((a,b)=>
    Number(commentary(a))-Number(commentary(b)) ||
    Number(trackLanguage(b)===want)-Number(trackLanguage(a)===want) ||
    Number(a.isForced)-Number(b.isForced) || Number(b.isDefault)-Number(a.isDefault)
  );
}
export function preferredAudioTrack(tracks: MediaTrack[], preferred: string): number {
  const audio=tracks.filter(t=>t.kind==='audio');
  const match=orderedMatches(audio,preferred)[0];
  if(match) return match.index;
  // A saved language is a constraint. The caller must handle no match before
  // loading; omitting audioIndex would let the engine choose a foreign default.
  if (preferred.trim()) return -1;
  // An explicitly empty preference permits the file default.
  const ordinary=audio.filter(t=>!commentary(t));
  return (ordinary.find(t=>t.isDefault) ?? ordinary[0] ?? audio[0])?.index ?? -1;
}
export function preferredSubtitleTrack(tracks: MediaTrack[], preferred: string, enabled: boolean): number | null {
  if(!enabled) return null;
  const usable=tracks.filter(t=>t.kind==='subtitle' && t.passthrough);
  if(preferred) return orderedMatches(usable,preferred)[0]?.index ?? null;
  return usable.find(t=>t.isDefault)?.index ?? null;
}
